import axios from "axios";
import { endpoints } from "../../../api/endpoint";

export const sanitizeForEmail = (name = "") =>
  name.replace(/[^a-zA-Z0-9._-]/g, "_").toLowerCase();

export const generateDriverEmail = (name = "") =>
  `${sanitizeForEmail(name)}.bp@gmail.com`;

export const buildDriverPayloadFromLead = (leadData) => {
  if (!leadData) return null;

  const loanSummary = leadData.loanSummary || {};

  const driverName = leadData.driverName || "";
  const phoneNumber = leadData.phoneNumber || "";

  return {
    name: driverName,
    driverId: leadData.driverId || "",
    city: leadData.city || "",
    phoneNumber,
    email: generateDriverEmail(phoneNumber),
    driverOrganization: loanSummary.financier || "",
    dailyEmi: loanSummary?.emi?.daily || "",
    inActiveDays: 0,
    vehicleCategory: "3",
    swapFeeArr: [1000, 1000, 1000, 1000],
    driverCurrentStatus: "Onboarded/Active",
    model: "RentalCharger",
    penaltyFee: loanSummary?.emi?.daily || 130,

    registrationSource: "DEALER_LEAD",
    leadId: leadData.leadId || "",
  };
};

export const registerDriverFromLead = async (leadData) => {
  const payload = buildDriverPayloadFromLead(leadData);

  if (!payload) {
    return {
      success: false,
      error: "No lead data available to register driver",
    };
  }

  try {
    const response = await axios.post(
      endpoints.createDriverOfOnboarding,
      payload,
    );
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Something went wrong while registering the driver",
    };
  }
};
